<template>
  <div>


    <!-- 顶部总计卡片 -->
    <el-row :gutter="16" class="summary-row">
  <el-col :span="12">
    <div class="summary-item oppo-summary">
      <span class="summary-label">OPPO 总计消费：</span>
      <span class="summary-value">¥ {{ oppoTotal.toFixed(2) }}</span>
    </div>
  </el-col>
  <el-col :span="12">
    <div class="summary-item vivo-summary">
      <span class="summary-label">VIVO 总计消费：</span>
      <span class="summary-value">¥ {{ vivoTotal.toFixed(2) }}</span>
    </div>
  </el-col>
</el-row>


    <!-- 统一的查询表单 -->
    <el-form :inline="true" class="query-form">
      <el-form-item label="开始日期">
        <el-date-picker v-model="beginTime" type="date" placeholder="开始日期" style="width:140px"/>
      </el-form-item>
      <el-form-item label="结束日期">
        <el-date-picker v-model="endTime" type="date" placeholder="结束日期" style="width:140px"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="fetchAllData" :loading="loading">查询</el-button>
      </el-form-item>
    </el-form>

    <!-- 折叠面板：OPPO部分 -->
    <el-collapse v-model="activeCollapse" class="data-collapse">
      <el-collapse-item title="OPPO 消费数据" name="oppo">
        <div class="collapse-content">
          <!-- OPPO表格 -->
          <el-table :data="oppoTableData" border style="width:100%" v-loading="oppoLoading">
            <el-table-column prop="advName" label="名称" min-width="200"/>
            <el-table-column prop="cost" label="消费汇总" sortable min-width="150">
              <template #default="scope">
                <span class="oppo-cost">¥ {{ formatCost(scope.row.cost) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-collapse-item>

      <!-- 折叠面板：VIVO部分 -->
      <el-collapse-item title="VIVO 消费数据" name="vivo">
        <div class="collapse-content">
          <!-- VIVO表格 -->
          <el-table :data="vivoTableData" border style="width:100%" v-loading="vivoLoading">
            <el-table-column prop="advName" label="名称" min-width="180">
              <template #default="scope">
                <span>{{ scope.row.advName }}</span>
                <el-tag size="small" :type="getRegionTagType(scope.row.region)" class="region-tag" v-if="scope.row.region">
                  {{ scope.row.region }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="cost" label="消费汇总" sortable min-width="150">
              <template #default="scope">
                <span class="vivo-cost">¥ {{ formatCost(scope.row.cost) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import sha1 from 'sha1'

export default {
  data() {
    return {
      // 统一的时间
      beginTime: '',
      endTime: '',
      loading: false,

      // 折叠面板激活项
      activeCollapse: ['oppo', 'vivo'], // 默认都展开

      // OPPO相关
      oppoTableData: [],
      oppoLoading: false,

      // VIVO相关
      vivoTableData: [],
      vivoLoading: false,
      vivoCookies: [],

      // OPPO账户列表
      oppoAccounts: [
        { advName:'爱客美', owner_id:'1001123153', api_id:'f032e296fa924b07b36abb738bf82caf', api_key:'7fc7bd8baebf405284e74a898c02e4da', owner_type:"0" },
        { advName:'志隆', owner_id:'1000659564', api_id:'f9b0d62e8aa34d50ba96e83286382a42', api_key:'43fdc5d9786742f38169746d23536048', owner_type:"3" },
        { advName:'力天', owner_id:'1000659972', api_id:'bf1a255586f24c169db0fac9004e4854', api_key:'256cb953fdce4da79be7be3b40430dac', owner_type:"0" },
        { advName:'亨利', owner_id:'1001127104', api_id:'274c15d04f45407997e899a439097025', api_key:'7a12fdeb147a4bb7a538131008733b50', owner_type:"0" },
        { advName:'开域', owner_id:'1001133919', api_id:'0d542fddb3b84e4c8684aa9f6352eebd', api_key:'b8f40f544c2842b78d82677948e1250c', owner_type:"0" },
        { advName:'胜昔', owner_id:'1001121812', api_id:'e48026e0cdc644d7b64e7441ac5175a5', api_key:'446bd835d91a4f1a87f764cf7567f903', owner_type:"0" },
        { advName:'微创', owner_id:'1001139580', api_id:'dde1a51fe3144202a2db49daf7140e07', api_key:'a5db0fde94ae479183afd0612e03816c', owner_type:"0" },
        { advName:'爱德', owner_id:'1001156946', api_id:'2e82baccc62a43ecbff8617271105a3d', api_key:'5be6abd0a35b429b84b62022fd042150', owner_type:"0" },
        { advName:'哇棒', owner_id:'1001154688', api_id:'f5ef858aa3c046faa7a89fee11e77585', api_key:'cec345146dd0451982a9f35ceae95eb8', owner_type:"0" }
      ]
    }
  },
  computed: {
    // OPPO总计
    oppoTotal() {
      return this.oppoTableData.reduce((sum, item) => sum + (Number(item.cost) || 0), 0)
    },
    // VIVO总计
    vivoTotal() {
      return this.vivoTableData.reduce((sum, item) => sum + (Number(item.cost) || 0), 0)
    }
  },
  mounted() {
    // 设置默认日期为昨天
    const d = new Date();
    d.setDate(d.getDate() - 1)

    this.beginTime = d;
    this.endTime = d;

    // 获取VIVO cookies
    this.fetchVivoCookies();
  },
  methods: {
    // 格式化金额
    formatCost(val) {
      return Number(val || 0).toFixed(2)
    },
    // 格式化日期为yyyymmdd格式（用于OPPO接口）
    formatDateCompact(d) {
      if (!d) return ''
      d = new Date(d)
      return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`
    },
    // 格式化日期为yyyy-mm-dd格式（用于VIVO接口）
    formatDate(d) {
      if (!d) return ''
      d = new Date(d)
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    },
    // 生成OPPO token
    generateToken(o, i, k) {
      const t = Math.floor(Date.now() / 1000)
      return btoa(`${o},${i},${t},${sha1(i + k + t)}`)
    },
    // 获取区域标签类型
    getRegionTagType(region) {
      const map = {
        '深圳': 'danger',
        '苏州': 'danger'
      }
      return map[region] || 'info'
    },
    // 获取VIVO cookie列表
    fetchVivoCookies() {
      this.$axios.get('https://control.zjwec.cn/api/hdcookie/page', {
        params: {
          pageNum: 1,
          uid: 1,
          role: 1,
          pageSize: 10
        }
      }).then(res => {
        if (res.data.code === "0") {
          this.vivoCookies = res.data.data.records || [];
          // 获取到cookies后自动查询昨天的数据
          this.fetchAllData();
        }
      }).catch(err => {
        console.error('获取VIVO cookies失败:', err);
        this.$message.error('获取VIVO cookies失败');
      })
    },
    // 查询所有数据
    fetchAllData() {
      if (!this.beginTime || !this.endTime) {
        this.$message.warning('请选择日期范围');
        return;
      }

      this.loading = true;
      this.oppoLoading = true;
      this.vivoLoading = true;

      // 同时查询OPPO和VIVO数据
      Promise.all([
        this.fetchOppoDataInternal(),
        this.fetchVivoDataInternal()
      ]).finally(() => {
        this.loading = false;
      });
    },
    // 内部查询OPPO数据
    fetchOppoDataInternal() {
      const reqs = this.oppoAccounts.map(a => {
        const body = {
          page: 1,
          pageCount: 500,
          beginTime: this.formatDateCompact(this.beginTime),
          endTime: this.formatDateCompact(this.endTime),
          timeLevel: 'DAY',
          paraMap: {
            subAccList: ["1", "0", "9999"],
            // owner_type: a.owner_type,
            extensionFlowList: ["1", "2", "3"],
            flowSceneList: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15"],
            groupByColumn: "owner_id"
          }
        }

        return this.$axios.post(
          'apis/v3/data/common/agency/query/queryOwnerCost',
          body,
          { headers: { Authorization: `Bearer ${this.generateToken(a.owner_id, a.api_id, a.api_key)}` } }
        ).then(r => {
          const list = r.data.data.items || []
          const total = list.reduce((s, i) => s + Number(i.cost || 0), 0)
          return {
            advName: a.advName,
            cost: total / 100
          }
        }).catch(err => {
          console.error(`OPPO账户 ${a.advName} 查询失败:`, err);
          return {
            advName: a.advName,
            cost: 0
          };
        })
      })

      return Promise.all(reqs).then(res => {
        this.oppoTableData = res;
        this.oppoLoading = false;
      });
    },
    // 内部查询VIVO数据（只查深圳和苏州）
    fetchVivoDataInternal() {
      if (!this.vivoCookies || this.vivoCookies.length === 0) {
        this.vivoLoading = false;
        return Promise.resolve([]);
      }

      const formattedStartDate = this.formatDate(this.beginTime);
      const formattedEndDate = this.formatDate(this.endTime);

      // 只过滤出深圳和苏州的cookie
      const targetCookies = this.vivoCookies.filter(cookie =>
        cookie.hdname.includes('深圳') || cookie.hdname.includes('苏州')
      );

      if (targetCookies.length === 0) {
        this.vivoLoading = false;
        this.vivoTableData = [];
        return Promise.resolve([]);
      }

      const reqs = targetCookies.map(cookie => {
        // 确定区域标识
        let region = cookie.hdname;

        // 选择接口：深圳用hdconsume，苏州用edconsume
        const isShenzhen = cookie.hdname.includes('深圳');
        const apiUrl = isShenzhen ? 'https://control.zjwec.cn/api/vivo/hdconsume' : 'https://control.zjwec.cn/api/vivo/hdconsume';

        const body = {
          cookie: cookie.hdcookie,
          startDate: formattedStartDate,
          endDate: formattedEndDate
        };

        return this.$axios.post(apiUrl, body)
          .then(res => {
            // 解析返回数据
            let consume = 0;

              consume =res.data.raw.data.consumeAmount



            return {
              advName: `VIVO-${cookie.hdname}`,
              cost: Number(consume),
              region: region
            };
          })
          .catch(err => {
            console.error(`VIVO ${cookie.hdname} 查询失败:`, err);
            return {
              advName: `VIVO-${cookie.hdname}`,
              cost: 0,
              region: region
            };
          });
      });
      // 测试
      return Promise.all(reqs).then(res => {
        this.vivoTableData = res;
        this.vivoLoading = false;
      });
    }
  }
}
</script>

<style scoped>
.query-form {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

/* 顶部总计卡片样式 */
.summary-cards {
  margin-bottom: 20px;
}

.summary-card {
  border-radius: 8px;
  transition: all 0.3s;
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
}

.oppo-summary {
  background: linear-gradient(135deg, #ecf5ff 0%, #d9ecff 100%);
  border-left: 4px solid #409EFF;
}

.vivo-summary {
  background: linear-gradient(135deg, #f0f9eb 0%, #e1f3d8 100%);
  border-left: 4px solid #67C23A;
}

.summary-content {
  padding: 15px 20px;
}

.summary-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.summary-value {
  font-size: 24px;
  font-weight: 700;
  color: #F56C6C;
}

.data-collapse {
  margin-top: 10px;
}

.collapse-content {
  padding: 15px 0;
}

/* 表格样式 */
:deep(.el-table) {
  font-size: 13px;
  margin-bottom: 15px;
}

:deep(.el-table th) {
  background-color: #f5f7fa;
  font-weight: 600;
  color: #333;
}

.region-tag {
  margin-left: 8px;
}

/* 消费金额颜色标识 */
.oppo-cost {
  color: #409EFF;
  font-weight: 500;
}

.vivo-cost {
  color: #67C23A;
  font-weight: 500;
}

/* 折叠面板标题样式 */
:deep(.el-collapse-item__header) {
  font-weight: 600;
  font-size: 16px;
  background-color: #f5f7fa;
  padding-left: 15px;
}

:deep(.el-collapse-item__content) {
  padding-bottom: 0;
}

/* 手机端适配 */
@media (max-width: 768px) {
  .query-form :deep(.el-form-item) {
    display: block;
    margin-right: 0;
    margin-bottom: 10px;
    width: 100%;
  }

  .query-form :deep(.el-form-item__content) {
    width: 100%;
  }

  .query-form :deep(.el-date-picker) {
    width: 100% !important;
  }

  .query-form :deep(.el-button) {
    width: 100%;
  }

  .summary-cards {
    margin-bottom: 15px;
  }

  .summary-card {
    margin-bottom: 10px;
  }

  .summary-value {
    font-size: 20px;
  }
}

.summary-row {
  margin-bottom: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 12px 15px;
}

.summary-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}

.summary-label {
  font-size: 14px;
  font-weight: 500;
  color: #606266;
}

.summary-value {
  font-size: 18px;
  font-weight: 700;
  color: #F56C6C;
}

.oppo-summary .summary-label {
  color: #409EFF;
}

.vivo-summary .summary-label {
  color: #67C23A;
}

/* 手机端适配 */
@media (max-width: 768px) {
  .summary-row {
    padding: 10px;
  }

  .summary-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }

  .summary-value {
    font-size: 16px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/login/szAllData.vue